const MAX_FRACTIONAL_PARTS = 2;

const formatZero = (precision: number) => {
  if (precision === 0) {
    return '0';
  }
  if (precision === 1) {
    return '0.0';
  }
  return '0.00';
};

type FormatAmountProps = {
  amount: string;
  precision: number;
  isTruncated?: boolean;
};
export const formatAmount = ({
  amount,
  precision,
  isTruncated = false,
}: FormatAmountProps) => {
  if (amount === '0' && isTruncated) {
    return formatZero(precision);
  }
  let preformattedAmount = amount;
  const isNegative = preformattedAmount.charAt(0) === '-';
  if (isNegative) {
    preformattedAmount = preformattedAmount.slice(1);
  }
  if (preformattedAmount.length < precision) {
    preformattedAmount = preformattedAmount.padStart(precision, '0');
  }
  const integerPart =
    preformattedAmount.slice(0, preformattedAmount.length - precision) || '0';
  const formattedIntegerPart = `${isNegative ? '-' : ''}${Intl.NumberFormat(
    'en-US'
  ).format(BigInt(integerPart))}`;
  if (precision === 0) {
    return formattedIntegerPart;
  }
  let fractionalPart = preformattedAmount.slice(
    preformattedAmount.length - precision
  );
  if (isTruncated && fractionalPart) {
    if (fractionalPart.length > MAX_FRACTIONAL_PARTS + 1) {
      fractionalPart = `${fractionalPart.slice(
        0,
        MAX_FRACTIONAL_PARTS
      )}&#8230;`;
    }
  }
  return `${formattedIntegerPart}.${fractionalPart}`;
};
